export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/8fd368287aa22ec0bce40923b7cf1187.svg";